export default {
  namespaced: true,
  state: {
    addressId: null,
    parsedErrors: []
  },
  mutations: {
    SET_ADDRESS_ID(state, payload) {
      state.addressId = payload;
    },
    SET_ERRORS (state, payload) {
      state.parsedErrors = payload;
    },
    EMPTY_ERRORS (state) {
      state.parsedErrors = [];
    }
  },
}



// WEBPACK FOOTER //
// ./src/stores/addresses-modal.store.js